import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";
import { Booking } from "../app/Bookings/model";

const updateBookingStatus = async (bookingId: string, status: string, brand: Booking["brand"]) => {
  return fetch(`/api/bookings/${bookingId}/status`, "PATCH", { status, brand });
};

export const useUpdateBookingStatus = (bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { status: string; brand: Booking["brand"]; toastId: any }) =>
      updateBookingStatus(bookingId, data.status, data.brand),
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);

      toast({
        title: "Success",
        description: "Booking status updated successfully!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.message || "Failed to update booking status!",
        variant: "destructive",
      });
    },
  });
};
